import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/landing/banner-img.png'
import _imports_1 from '@/assets/images/landing/shape-3.png'
import _imports_2 from '@/assets/images/landing/shape-4.png'
import _imports_3 from '@/assets/images/landing/shape-5.png'
import _imports_4 from '@/assets/images/landing/shape-6.png'


const _hoisted_1 = {
  class: "banner-area bg-img pb-0",
  id: "home"
}
const _hoisted_2 = { class: "container position-relative z-1" }
const _hoisted_3 = { class: "banner-content text-center pb-75" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "fs-60 mb-3 pb-md-3" }, " Insights On-the-Go: Access Your Dashboard Anywhere, Anytime ", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "fs-18 m-auto mb-3 pb-md-3 mw-740" }, " Our intuitive interface transforms complex data into actionable insights, empowering you to make informed decisions with confidence. ", -1)),
        _createVNode(_component_RouterLink, {
          to: "/contact",
          class: "btn btn-primary py-2 px-4 fs-16 fw-medium rounded-3"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "ri-user-line fs-18" }, null, -1),
            _createElementVNode("span", { class: "ms-1" }, "Get started - It is free", -1)
          ])),
          _: 1
        })
      ]),
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"banner-img-wrap text-center\"><img src=\"" + _imports_0 + "\" alt=\"banner-img\"></div><img src=\"" + _imports_1 + "\" class=\"shape shape-7\" alt=\"shape\"><img src=\"" + _imports_2 + "\" class=\"shape shape-8\" alt=\"shape\"><img src=\"" + _imports_3 + "\" class=\"shape shape-9\" alt=\"shape\"><img src=\"" + _imports_4 + "\" class=\"shape shape-10\" alt=\"shape\">", 5))
    ])
  ]))
}